var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSmsSelected({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/bold/sms"
  }, /*#__PURE__*/React.createElement("g", {
    id: "sms"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9.91669 2.04199H4.08335C2.33335 2.04199 1.16669 2.91699 1.16669 4.95866V9.04199C1.16669 11.0837 2.33335 11.9587 4.08335 11.9587H9.91669C11.6667 11.9587 12.8334 11.0837 12.8334 9.04199V4.95866C12.8334 2.91699 11.6667 2.04199 9.91669 2.04199ZM10.1909 5.59449L8.36502 7.05283C7.98002 7.36199 7.49002 7.51366 7.00002 7.51366C6.51002 7.51366 6.01419 7.36199 5.63502 7.05283L3.80919 5.59449C3.62252 5.44283 3.59335 5.16283 3.73919 4.97616C3.89085 4.78949 4.16502 4.75449 4.35169 4.90616L6.17752 6.36449C6.62085 6.72033 7.37335 6.72033 7.81669 6.36449L9.64252 4.90616C9.82919 4.75449 10.1092 4.78366 10.255 4.97616C10.4067 5.16283 10.3775 5.44283 10.1909 5.59449Z",
    fill: "#3A86FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmsSelected);
export default __webpack_public_path__ + "static/media/sms-selected.4f2d952ee5507095c0e82a139089660e.svg";
export { ForwardRef as ReactComponent };